const faqItems = [
  {
    q: '51电影网的资讯更新频率是怎样的？',
    a: '51电影网保持7×24小时全天候追踪报道，每日更新超过200条影视资讯，涵盖电影上映排期、幕后花絮揭秘、明星动态追踪、票房数据分析及争议事件深度报道，确保影迷第一时间获取最新影视圈动态。',
  },
  {
    q: '如何获取最新的票房黑马和争议事件报道？',
    a: '您可以通过首页"实时追踪快讯"模块查看最新票房动态，在"热门榜单"中了解票房排名变化，同时在"焦点专题"区域深度阅读争议事件的独家追踪报道与分析评论。',
  },
  {
    q: '51电影网的独家幕后揭秘内容从哪里来？',
    a: '我们的编辑团队与国内外影视制作方、发行方及媒体机构保持紧密合作，同时拥有资深的娱乐记者和影评人团队，每日产出超过50条独家幕后花絮、片场直击及明星专访内容。',
  },
  {
    q: '能否通过手机随时随地浏览51电影网？',
    a: '可以。51电影网提供移动客户端，适配手机与平板设备，您可以在"移动客户端"板块了解详情。同时网站采用响应式设计，通过浏览器也能获得流畅的移动端浏览体验。',
  },
  {
    q: '我想爆料或投稿，该怎么联系你们？',
    a: '欢迎通过"投稿爆料"板块与我们取得联系。无论是独家线索、行业爆料还是影评投稿，我们的编辑团队都会认真对待每一条来自读者的信息。',
  },
  {
    q: '51电影网的电影评分和榜单数据可信吗？',
    a: '51电影网的热门榜单综合了院线票房数据、主流平台评分、社交媒体讨论热度及专业影评人评价等多个维度，力求全面客观地反映电影的市场表现与口碑。具体评分规则详见各榜单说明。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[960px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            影视追踪问答
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-[560px] mx-auto">
            关于电影追踪、幕后揭秘与明星动态的常见问题解答
          </p>

          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <details
                key={i}
                className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
              >
                <summary className="flex items-center justify-between px-5 py-4 md:px-6 md:py-5 list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4 font-heading">
                    {item.q}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 flex-shrink-0 transition-colors">
                    <i className="ri-add-line text-sm text-foreground-500 group-open:hidden"></i>
                    <i className="ri-subtract-line text-sm text-primary-600 hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}